import { render, staticRenderFns } from "./physique.vue?vue&type=template&id=3f766c50&scoped=true"
import script from "./physique.vue?vue&type=script&lang=js"
export * from "./physique.vue?vue&type=script&lang=js"
import style0 from "./physique.vue?vue&type=style&index=0&id=3f766c50&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f766c50",
  null
  
)

export default component.exports